import { useAppSelector } from "@/Hook/hooks";
import { ControlTranslation } from "AlignComponents";
import { Card } from "react-bootstrap";
import { LuCalendarMinus } from "react-icons/lu";

const MyBalance = () => {
  const { leaveBalance } = useAppSelector(x => {

    return {
      leaveBalance: x.Home.SelfService.leaveBalance
    }
  })
  return (
    <div className="widget my-balances">
      <Card>
        <Card.Header>
          <Card.Title>
            <LuCalendarMinus size={18} className="icon" />
            <ControlTranslation system={true} controlId="lblmyleavebalances" />
          </Card.Title>
        </Card.Header>
        <Card.Body>
          <div className="tiles">
            {
              leaveBalance.map(x => (
                <div className="tile">
                  <span>{x.leavetypestxt}</span>
                  <h6>{x.balance}</h6>
                </div>
              ))
            }
          </div>
          {/* <h6 className="title">
            <ControlTranslation system={true} controlId="lblleaverequests" />
          </h6> */}

          {/* <div className="leave-requests">
            <div className="leave-request">
              <div className="text">
                <h6>Leave Request for Personal Commitment</h6>
                <span>Requesting a day off on Dec 12 for a personal matter...</span>
              </div>
              <div className="badge bg-outline-dark ms-auto fs-10">
                Dec 12, 2024
              </div>
            </div>


            <div className="leave-request">
              <div className="text">
                <h6>Annual Leave Application</h6>
                <span>Planning a family trip, requesting leave from Dec 15-20...</span>
              </div>
              <div className="badge bg-outline-dark ms-auto fs-10">
                Dec 15-20, 2024
              </div>
            </div>

            <div className="leave-request">
              <div className="text">
                <h6>Sick Leave Needed</h6>
                <span>Feeling unwell and requesting leave to recover on Dec 2-3...</span>
              </div>
              <div className="badge bg-outline-dark ms-auto fs-10">
                Dec 2-3, 2024
              </div>
            </div>
          </div> */}
        </Card.Body>
      </Card>
    </div >
  )
};

export default MyBalance;